import { z } from 'src/lib'
import { OperacionCorporateCuentaFields, OperacionCorporateFields } from './fields'
import { schemaEntityWithId } from 'src/types'

export const schemaOperacionCorporate = z
    .object({
        [OperacionCorporateFields.CodPais]: z.number(),
        [OperacionCorporateFields.NombrePais]: z.string(),
        [OperacionCorporateFields.CodEstado]: z.number(),
        [OperacionCorporateFields.CodSectorComercial]: z.number(),
        [OperacionCorporateFields.NombreSectorComercial]: z.string(),
        [OperacionCorporateFields.FechaVencimiento]: z.coerce.date(),
        [OperacionCorporateFields.FechaAprobacion]: z.coerce.date(),
        [OperacionCorporateFields.IdUsuarioAlta]: z.number(),
        [OperacionCorporateFields.NombreUsuarioAlta]: z.string(),
        [OperacionCorporateFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionCorporateFields.MailUsuarioAlta]: z.string(),
        [OperacionCorporateFields.PermiteEditar]: z.boolean(),
        [OperacionCorporateFields.PermiteEliminar]: z.boolean()
    })
    .merge(schemaEntityWithId)

export type OperacionCorporate = z.infer<typeof schemaOperacionCorporate>

export const schemaFormOperacionCorporate = z
    .object({
        [OperacionCorporateFields.FechaAprobacion]: z.date(),
        [OperacionCorporateFields.FechaVencimiento]: z.date(),
        [OperacionCorporateFields.CodSectorComercial]: z.number()
    })
    .refine(
        schema =>
            schema.fechaVencimiento ? schema.fechaVencimiento.getTime() >= schema.fechaAprobacion.getTime() : true, // No uso computed key porque: https://github.com/microsoft/TypeScript/issues/10530
        {
            message: 'La fecha de vencimiento debe ser mayor a la fecha de emisión.',
            path: [OperacionCorporateFields.FechaVencimiento]
        }
    )

export type FormOperacionCorporate = z.infer<typeof schemaFormOperacionCorporate>

const schemaDetalle = z
    .object({
        [OperacionCorporateCuentaFields.Sector]: z.string(),
        [OperacionCorporateCuentaFields.ImporteConcertacion]: z.number(),
        [OperacionCorporateCuentaFields.ImporteDPV]: z.number(),
        [OperacionCorporateCuentaFields.ImporteFOP]: z.number(),
        [OperacionCorporateCuentaFields.PermiteModificar]: z.boolean(),
        [OperacionCorporateCuentaFields.Estilo]: z.string().nullable(),
    })
    .merge(schemaEntityWithId)

export type CuentaCorporateDetalle = z.infer<typeof schemaDetalle>

export const schemaCuentaCorporate = z
    .object({
        [OperacionCorporateCuentaFields.NroCuenta]: z.string(),
        [OperacionCorporateCuentaFields.RazonSocial]: z.string(),
        [OperacionCorporateCuentaFields.CodMoneda]: z.number(),
        [OperacionCorporateCuentaFields.DescMoneda]: z.string(),
        [OperacionCorporateCuentaFields.SimboloMoneda]: z.string(),
        [OperacionCorporateCuentaFields.Detalles]: z.array(schemaDetalle)
    })
    .merge(schemaEntityWithId)

export const schemaCuentasCorporate = z.array(schemaCuentaCorporate)

export type CuentaCorporate = z.infer<typeof schemaCuentaCorporate>
export type CuentasCorporate = z.infer<typeof schemaCuentasCorporate>
